/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {

    addItem({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post("/AddUser", item)
                .then((response) => {
                    commit('ADD_ITEM', Object.assign(item, { Id: response.data.Id }))
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    fetchDataListItems({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/GetAllUsers")
                .then((response) => {
                    commit('SET_USERS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    GetAllRoles({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get("/GetAllRoles")
                .then((response) => {
                    commit('SET_ROLES', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },


    updateItem({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post("/UpdateUser", item)
                .then((response) => {
                    commit('UPDATE_USER', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    UpdatePassword(context, item) {
        return new Promise((resolve, reject) => {
            axios.post("/UpdatePassword", item)
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    SendCode(context, email) {
        return new Promise((resolve, reject) => {
            axios.post("/SendVerifyCodeForForgetPassword?email=" + email)
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    ResetPassword(context, item) {
        debugger
        return new Promise((resolve, reject) => {
            axios.get("api/Account/ResetPassword", {
                    params: {
                        email: item.email,
                        code: item.code,
                        newPassword: item.password
                    }

                })
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    VerifyCodeForConfirmEmail(context, item) {
        debugger
        return new Promise((resolve, reject) => {
            axios.get("VerifyCodeForConfirmEmail", {
                    params: {
                        email: item.Email,
                        code: item.Code
                    }

                })
                .then((response) => {

                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

    removeUser({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.delete("/deleteUser?ID=" + item)
                .then((response) => {
                    commit('REMOVE_ITEM', item)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

}